module.exports = __webpack_public_path__ + "img/Date-time.5b0c66e.png";